module.exports = __webpack_public_path__ + "img/pic-04.640fc46e.png";